import { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const useAlert = () => {
  const [alert, setAlert] = useState({ open: false, severity: "info", message: "" });

  const showAlert = (message, severity = "info") => {
    setAlert({ open: true, severity, message });
  };

  const closeAlert = () => {
    setAlert({ ...alert, open: false });
  };

  const alertElement = (
    <Snackbar
      open={alert.open}
      autoHideDuration={3000}
      onClose={closeAlert}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        top: "64px !important",
        zIndex: 1400, 
      }}
      
    >
      <Alert onClose={closeAlert} severity={alert.severity} sx={{ width: "100%" }}>
        {alert.message}
      </Alert>
    </Snackbar>
  );

  return { showAlert, alertElement };
};

export default useAlert;
